import { render } from "./cellCDate.vue?vue&type=template&id=68cac73d&scoped=true"
import script from "./cellCDate.vue?vue&type=script&lang=js"
export * from "./cellCDate.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-68cac73d"

export default script